


















































































import { Component, Vue, Prop } from "vue-property-decorator"
import moment from 'moment'

@Component
export default class RunStep extends Vue{
    @Prop() step: any
    @Prop() index: number

    dialogChrono = false

    types = [
        { text: "Chrono", value: "CHRONO" },
        { text: "Pause", value: "PAUSE" }
    ]

    get min() {
        const min = []
        for(let i = 0; i <= 20; i++) {
            min.push(i)
        }
        return min
    }

    sec = [0, 15, 30, 45]

    formatChrono(time: any) {
        if(time.min === 0 && time.sec === 0) return "00:00"
        return moment(time.min + ":" + time.sec, "mm:ss").format("mm:ss");
    }
}
